import { createContext, useContext } from "react";

import type { CardContextValue } from "./types";

const defaultCardContext: CardContextValue = {
  state: "idle",
  direction: "col",
  disabled: false,
};

/**
 * Exposes the parent Card's `state` / `direction` / `disabled` to
 * sub-components so `Card.Title` and `Card.Description` resolve their
 * colour from the root rather than repeating the prop on every child.
 */
export const CardContext = createContext<CardContextValue>(defaultCardContext);

export const useCardContext = (): CardContextValue => useContext(CardContext);
